export enum FeatureToggle {
  CustomRolesV2 = 'rt_custom_roles_v2',
  userGroupsEnabled = 'rt_role_groups_enabled',
}
